"use client";

import Chip from "@/components/atoms/chip/Chip";
import useMyAgents from "@/features/myAgent/hooks/useMyAgents";

const ValueMyAgent = () => {
  const { myAgents } = useMyAgents();

  return (
    <Chip label={`${myAgents ? myAgents.info?.totalCount : 0}`} color="white" />
  );
};

export const VALUE_MY_AGENT = <ValueMyAgent />;
